module.exports = __webpack_public_path__ + "img/ornament.67ad91f2.svg";